import { render, staticRenderFns } from "./ModalAddImages.vue?vue&type=template&id=6a2f19c4"
import script from "./ModalAddImages.vue?vue&type=script&lang=js"
export * from "./ModalAddImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports